// extracted by mini-css-extract-plugin
module.exports = {"root":"O_mCH","icon":"AJLig","text":"qE5Hr"};